import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'output'];

  submit(event) {
    event.preventDefault();

    const value = this.inputTarget.value;
    const docInfo = this.extractDocInfo(value);

    if (!docInfo || !docInfo.id) {
      alert('Please enter a valid Google Docs URL');
      return;
    }

    const output = `https://docs.google.com/${docInfo.type}/d/${docInfo.id}/copy`;
    this.lastOutput = output;
    navigator.clipboard.writeText(output);

    document.getElementById("copiedToClipboardDiv").classList.remove('hidden')
    this.outputTarget.innerHTML = `Copied to clipboard: ${ output }`;
  }

  // Click the result box to copy it again.
  copy() {
    if (!this.lastOutput) return;

    navigator.clipboard.writeText(this.lastOutput);
    this.flashCopied();
  }

  flashCopied() {
    const previous = this.outputTarget.innerHTML;
    this.outputTarget.innerHTML = 'Copied to clipboard!';

    window.clearTimeout(this.flashTimeoutId);
    this.flashTimeoutId = window.setTimeout(() => {
      this.outputTarget.innerHTML = previous;
    }, 1200);
  }

  extractDocInfo(url) {
    if (!url) return null;
    
    // Match Google Docs URL patterns and extract type and ID
    const patterns = {
      'spreadsheets': /\/spreadsheets\/d\/([-\w]{25,})/,
      'document': /\/document\/d\/([-\w]{25,})/,
      'presentation': /\/presentation\/d\/([-\w]{25,})/,
      'drawings': /\/drawings\/d\/([-\w]{25,})/,
      'forms': /\/forms\/d\/([-\w]{25,})/
    };
    
    for (const [type, pattern] of Object.entries(patterns)) {
      const match = url.match(pattern);
      if (match) {
        return { type: type, id: match[1] };
      }
    }
    
    return null;
  }
}